const CONTENT = {
  about: {
    title: "About Us",
    body: [
      "The Bihar Technical Service Commission (BTSC) was constituted by the Government of Bihar for recruitment to various technical posts under different departments of the State Government.",
      "The Commission conducts recruitment for posts such as Staff Nurse, Dresser, X-Ray Technician, Medical Officers, and various other technical and paramedical positions across the state.",
      "Located at 19, Harding Road, Patna – 800001, the Commission is committed to a transparent, fair and merit-based recruitment process.",
    ],
  },
  "act-and-rules": { title: "Act and Rules", body: ["Relevant Acts, Rules and Regulations governing recruitment will be published here."] },
  budgets: { title: "Budgets/Allotments", body: ["Budget and allotment details will be published here."] },
  recruitments: { title: "Recruitments", body: ["Current and past recruitment advertisements will appear here."] },
  syllabus: { title: "Syllabus", body: ["Syllabus for various posts will be published here as and when advertisements are released."] },
  "objection-portal": { title: "Objection Portal", body: ["Candidates may raise objections regarding answer keys and results through this portal during the notified window."] },
  "admit-card": { title: "Admit Card / Call Letter", body: ["Admit cards and call letters for scheduled examinations will be made available here."] },
  "score-card": { title: "Score Card", body: ["Candidates can download their score cards from this section after result declaration."] },
  tender: { title: "Tender", body: ["Tender notices and related documents will be published here."] },
};

export default function StaticPage({ slug }) {
  const page = CONTENT[slug] || { title: "Page", body: ["Content coming soon."] };
  return (
    <div className="inner-page" data-testid={`static-page-${slug}`}>
      <h1 className="page-title">{page.title}</h1>
      <div className="static-body">
        {page.body.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    </div>
  );
}
